var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsertExtraAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.9,1.9v20.1h1.3H7h1.3h5.3h1.3v-1.3h-1.3H8.2H7H3.2V7h17.6v5.3h1.3V1.9h-1.3H3.2H1.9z M16.6,3.2l1.7,1l1.7-1 l0.8,1l-2.1,1.3l-0.4,0.2l-0.4-0.2l-2.1-1.3L16.6,3.2z M7,8.2c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5 S8.4,8.2,7,8.2z M7,9.5c0.7,0,1.3,0.6,1.3,1.3S7.7,12,7,12s-1.3-0.6-1.3-1.3S6.3,9.5,7,9.5z M10.5,8.1v1.3H16V8.1H10.5z M18.6,9.9 L13.4,17l3.5-0.1v5.2l5.2-6.9h-3.5V9.9z M4.5,14.5v5h3.8h1.3v-1.3v-3.8H4.5z M5.7,15.8h2.5v2.5H5.7V15.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertExtraAction);
export default __webpack_public_path__ + "static/media/insert-extra-action.8420fafd330a1c6f00dc8ac5fe4dcba7.svg";
export { ForwardRef as ReactComponent };